import { LANG_MENU_ITEMS } from '@/components/lang/lang-menu-items';
import { ButtonBase, Menu, MenuItem } from '@mui/material';
import * as Flags from 'country-flag-icons/react/3x2';
import i18next from 'i18next';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaChevronDown } from 'react-icons/fa';

import { cn } from '@/lib/utils';

export interface LangMenuFlagProps {
  className?: string;
}

export default function LangMenuFlag({ className }: LangMenuFlagProps) {
  const { t: tBase } = useTranslation();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const Flag = Flags[tBase('flag')];
  return (
    <div className={cn(className)}>
      <ButtonBase
        sx={{
          display: 'flex',
          borderRadius: 0.5,
          gap: 1,
          p: 0.5,
          // Un drapeau de 20px et un chevron font 48x21 : la hauteur se rate au
          // pouce. Le dessin ne bouge pas, la zone tactile s'élargit sous md.
          justifyContent: 'center',
          minWidth: { xs: 44, md: 0 },
          minHeight: { xs: 44, md: 0 },
        }}
        onClick={handleClick}
      >
        <Flag className="w-5 rounded-[2px] overflow-hidden" />
        <FaChevronDown size={12} className="text-neutral-300" />
      </ButtonBase>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {LANG_MENU_ITEMS.map((l) => (
          <MenuItem
            key={l.key}
            onClick={() => {
              handleClose();
              i18next.changeLanguage(l.key);
              window.store.set('lang', l.key);
            }}
          >
            {l.value}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
